import "./App.css";
import Navbar from "./components/navbar";
import Body from "./components/body";

import { setLanguageToI18n } from "./services/i18n";

function App() {
  const [, langFromPath] = window.location.pathname.split("/");
  // se vier vazio ou inválido, cai no padrão "pt_BR"
  const chosenLang = langFromPath || "pt_BR";

  setLanguageToI18n(chosenLang);
  return (
    <div className="app" datatest-id="app-div">
      <Navbar></Navbar>
      <Body></Body>

      <div className="background" datatest-id="app-background"></div>
    </div>
  );
}

export default App;
